import { render } from "./OrderInfoItemWrapperComponent.vue?vue&type=template&id=54cf6cb6&scoped=true&ts=true"
import script from "./OrderInfoItemWrapperComponent.vue?vue&type=script&lang=ts"
export * from "./OrderInfoItemWrapperComponent.vue?vue&type=script&lang=ts"

import "./OrderInfoItemWrapperComponent.vue?vue&type=style&index=0&id=54cf6cb6&scoped=true&lang=css"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54cf6cb6"]])

export default __exports__